<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Centro de Distribuição
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="cd_centro_distribuicao">Código <sup class="text-danger">* </sup></label>
              <input id="cd_centro_distribuicao" v-model="registro.cd_centro_distribuicao" v-mask="'NNNNN'" type="text" style="text-transform:uppercase" class="form-control input-number" v-bind:class="{ 'box-input-required': errors.cd_centro_distribuicao }">
              <span v-show="errors.cd_centro_distribuicao != null" class="help-inline">{{ errors.cd_centro_distribuicao }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="descricao">Descrição <sup class="text-danger">* </sup></label>
              <input id="descricao" v-model="registro.descricao" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.descricao }">
              <span v-show="errors.descricao != null" class="help-inline">{{ errors.descricao }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.idc_status" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_status }">
                <option value="1">Ativo</option>
                <option value="2">Inativo</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="telefone">Telefone <sup class="text-danger">* </sup></label>
              <input id="telefone" v-model="registro.telefone" v-mask="'(##) ####-#####'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.telefone }">
              <span v-show="errors.telefone != null" class="help-inline">{{ errors.telefone }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_cep">CEP <sup class="text-danger">* </sup></label>
              <input id="end_cep" v-model="registro.end_cep" v-mask="'##.###-###'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_cep }" @keyup="pesquisarCEP()">
              <span v-show="errors.end_cep != null" class="help-inline">{{ errors.end_cep }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_logradouro">Logradouro <sup class="text-danger">* </sup></label>
              <input id="end_logradouro" v-model="registro.end_logradouro" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_logradouro }">
              <span v-show="errors.end_logradouro != null" class="help-inline">{{ errors.end_logradouro }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_numero">Número <sup class="text-danger">* </sup></label>
              <input id="end_numero" v-model="registro.end_numero" v-mask="'##########'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_numero }">
              <span v-show="errors.end_numero != null" class="help-inline">{{ errors.end_numero }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_complemento">Complemento </label>
              <input id="end_complemento" v-model="registro.end_complemento" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_complemento }">
              <span v-show="errors.end_complemento != null" class="help-inline">{{ errors.end_complemento }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_bairro">Bairro <sup class="text-danger">* </sup></label>
              <input id="end_bairro" v-model="registro.end_bairro" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_bairro }">
              <span v-show="errors.end_bairro != null" class="help-inline">{{ errors.end_bairro }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_cidade">Cidade <sup class="text-danger">* </sup></label>
              <input id="end_cidade" v-model="registro.end_cidade" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_cidade }">
              <span v-show="errors.end_cidade != null" class="help-inline">{{ errors.end_cidade }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_uf">UF <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.end_uf" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.end_uf }">
                <option value="AC">AC</option>
                <option value="AL">AL</option>
                <option value="AM">AM</option>
                <option value="AP">AP</option>
                <option value="BA">BA</option>
                <option value="CE">CE</option>
                <option value="DF">DF</option>
                <option value="ES">ES</option>
                <option value="GO">GO</option>
                <option value="MA">MA</option>
                <option value="MG">MG</option>
                <option value="MS">MS</option>
                <option value="MT">MT</option>
                <option value="PA">PA</option>
                <option value="PB">PB</option>
                <option value="PE">PE</option>
                <option value="PI">PI</option>
                <option value="PR">PR</option>
                <option value="RJ">RJ</option>
                <option value="RN">RN</option>
                <option value="RO">RO</option>
                <option value="RR">RR</option>
                <option value="RS">RS</option>
                <option value="SC">SC</option>
                <option value="SE">SE</option>
                <option value="SP">SP</option>
                <option value="TO">TO</option>
              </select>
              <span v-show="errors.end_uf != null" class="help-inline">{{ errors.end_uf }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_pais">País <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.end_pais" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.end_pais }">
                <option value="0639">ARGENTINA</option>
                <option value="0973">BOLIVIA</option>
                <option value="1058">BRASIL</option>
                <option value="1589">CHILE</option>
                <option value="1694">COLOMBIA</option>
                <option value="2399">EQUADOR</option>
                <option value="2496">ESTADOS UNIDOS</option>
                <option value="4936">MEXICO</option>
                <option value="5860">PARAGUAI</option>
                <option value="5894">PERU</option>
                <option value="8451">URUGUAI</option>
                <option value="8508">VENEZUELA</option>
              </select>
              <span v-show="errors.end_pais != null" class="help-inline">{{ errors.end_pais }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_latitude">Latitude </label>
              <input id="end_latitude" v-model="registro.end_latitude" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_latitude }">
              <span v-show="errors.end_latitude != null" class="help-inline">{{ errors.end_latitude }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_longitude">Longitude</label>
              <input id="end_longitude" v-model="registro.end_longitude" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_longitude }">
              <span v-show="errors.end_longitude != null" class="help-inline">{{ errors.end_longitude }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isValidCep } from '@brazilian-utils/validators'
import Actions from '../../actions/CentroDistribuicaoActions'
import MotoristaActions from '../../actions/MotoristaActions'

export default {
  name: 'novo',
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        cd_centro_distribuicao: '',
        descricao: '',
        telefone: '',
        end_cep: '',
        end_logradouro: '',
        end_numero: '',
        end_complemento: '',
        end_bairro: '',
        end_cidade: '',
        end_uf: '',
        end_pais: '1058',
        end_latitude: '',
        end_longitude: '',
        idc_status: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Novo'
  },
  methods: {
    voltar () {
      this.$router.push('/centro-distribuicao')
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.cd_centro_distribuicao) {
        this.errors.cd_centro_distribuicao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.descricao) {
        this.errors.descricao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.telefone) {
        this.errors.telefone = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_cep) {
        this.errors.end_cep = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (this.cepNaoEncontrado) {
        this.errors.end_cep = 'CEP não encontrado.'
        this.hasError = true
      }

      if (!this.registro.end_logradouro) {
        this.errors.end_logradouro = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_numero) {
        this.errors.end_numero = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_bairro) {
        this.errors.end_bairro = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_cidade) {
        this.errors.end_cidade = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_uf) {
        this.errors.end_uf = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_pais) {
        this.errors.end_pais = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        Actions.cadastrarCentroDistribuicao({
          cd_centro_distribuicao: this.registro.cd_centro_distribuicao,
          descricao: this.registro.descricao,
          telefone: this.registro.telefone,
          end_cep: this.registro.end_cep,
          end_logradouro: this.registro.end_logradouro,
          end_numero: this.registro.end_numero,
          end_complemento: this.registro.end_complemento,
          end_bairro: this.registro.end_bairro,
          end_cidade: this.registro.end_cidade,
          end_uf: this.registro.end_uf,
          end_pais: this.registro.end_pais,
          end_latitude: this.registro.end_latitude,
          end_longitude: this.registro.end_longitude,
          idc_status: this.registro.idc_status
        })
        .then(response => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push('/centro-distribuicao')
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
      }
    },
    pesquisarCEP () {
      if (isValidCep(this.registro.end_cep)) {
        if (this.ultimoCEP !== this.registro.end_cep) {
          this.ultimoCEP = this.registro.end_cep

          this.$parent.$parent.$data.showModalLoader = true

          MotoristaActions.pesquisarCep(this.registro.end_cep)
            .then(res => {
              this.registro.end_logradouro = res.logradouro
              this.registro.end_bairro = res.bairro
              this.registro.end_cidade = res.localidade
              this.registro.end_uf = res.uf

              this.errors.end_cep = null
              this.cepNaoEncontrado = false

              this.$parent.$parent.$data.showModalLoader = false
            })
            .catch(erro => {
              this.registro.end_logradouro = ''
              this.registro.end_bairro = ''
              this.registro.end_cidade = ''
              this.registro.end_uf = ''

              this.errors.end_cep = 'CEP não encontrado.'
              this.cepNaoEncontrado = true

              this.$parent.$parent.$data.showModalLoader = false
            })
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/centro-distribuicao/Novo.vue